module.exports = __webpack_public_path__ + "static/img/csm.ed6fdb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/csm.jpg
// module id = cG3F
// module chunks = 0